import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '&.MTHSContainer': {
    marginBottom: theme.spacing(6),
    height: theme.spacing(86.25),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    [theme.breakpoints.down('xl')]: {
      height: theme.spacing(75),
    },
    [theme.breakpoints.down('lg')]: {
      height: theme.spacing(30),
      padding: theme.spacing(2),
    },
    '& .MTHSDetails': {
      textAlign: 'center',
      color: theme.palette.common.fogWhite,
    },
    '& .MTHSButton': {
      padding: theme.spacing(1.25, 1.875),
      lineHeight: theme.spacing(2),
      '& .MuiSvgIcon-root': {
        height: theme.spacing(3),
        width: theme.spacing(3),
      },
    },
    '& .MTHSTitle': {
      marginBottom: theme.spacing(1.875),
      [theme.breakpoints.down('lg')]: {
        fontSize: theme.spacing(2.25),
        lineHeight: theme.spacing(4),
      },
    },
    '& .MTHSSubTitle': {
      marginBottom: theme.spacing(1.875),
      [theme.breakpoints.down('lg')]: {
        lineHeight: theme.spacing(5),
      },
    },
  },
  '& .MTHSBackground': {
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    '&.MTHSBackgroundImg': {
      zIndex: '-2',
      objectFit: 'cover',
      objectPosition: 'right 85% ',
      [theme.breakpoints.down('md')]: {
        objectPosition: 'center',
      },
    },
    '&.MTHSBackgroundOverlay': {
      zIndex: '-1',
      backgroundColor: 'rgba(48, 48, 48, 0.47)',
    },
  },
}));
export default StyledBox;
